var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile = function SvgFile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e8e5fe;}.cls-2{fill:#8075f2;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "budicon-file"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.9774,1.7122,21.2629,7H16.4961a.5006.5006,0,0,1-.5-.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.5,22a.5.5,0,0,1-.5-.5V1H3.5a.5.5,0,0,0-.5.5v22a.5.5,0,0,0,.5.5h18a.5.5,0,0,0,.5-.5V22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.561,6.8843,16.1191.4395A1.5007,1.5007,0,0,0,15.0582,0H3.5A1.5,1.5,0,0,0,2,1.5v22A1.5,1.5,0,0,0,3.5,25h18A1.5,1.5,0,0,0,23,23.5V7.9443A1.5,1.5,0,0,0,22.561,6.8843ZM21.2629,7H16.4961a.5006.5006,0,0,1-.5-.498l-.0186-4.79ZM22,23.5a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5V1.5A.5.5,0,0,1,3.5,1H14.9746l.0215,5.5059A1.5026,1.5026,0,0,0,16.4961,8H22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7,15.5a.5.5,0,0,0,.5.5h10a.5.5,0,0,0,0-1H7.5A.5.5,0,0,0,7,15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.5,12h6a.5.5,0,0,0,0-1h-6a.5.5,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.5,19H7.5a.5.5,0,0,0,0,1h10a.5.5,0,0,0,0-1Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file.03cba1bab1026fba61c14a79bf3d9521.svg";